import * as Sentry from "@sentry/react";
import getFormattedEnvironment from "../utils/helpers";

export default class SentryLoggerProvider {
  private readonly options: { dsn: string; environment?: string };

  constructor(options: { dsn: string; environment?: string }) {
    this.options = options;
  }

  setup() {
    Sentry.init({
      dsn: this.options.dsn,
      release: process.env.SENTRY_RELEASE || "dtection-dashboard@1.0.0",
      environment: getFormattedEnvironment(
        this.options.environment || "Production",
      ),
    });

    return {
      logRecordProcessors: [
        {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onEmit: (record: any) => {
            Sentry.captureMessage(`[LOG] ${record.body}`);
          },
        },
      ],
    };
  }
}
